/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-table-label',
    templateUrl: './table-label.component.html',
    styleUrls: ['./../table-global-styles.css', './table-label.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TableLabelComponent {
    /**
     * Labels strings
     */
    @Input() labels: string[] = [];
    /**
     * If a bold separator should be render evenly between labels from the top to bottom of the table
     */
    @Input() hasBoldSeparator: boolean;

    /**
     * Number of lines present in the table
     */
    @Input() numLines: number;

    private cellHeight = 48;

    get labelsGridSize(): string {
        let gridStyle = '';
        if (this.labels?.length > 0) {
            gridStyle = `grid-template-columns: repeat(${this.labels?.length}, 1fr)`;
        }
        return gridStyle;
    }

    get separatorHeight(): string {
        // 2 lines from label and header
        const tableHeight = (2 + this.numLines) * this.cellHeight;
        return `height: ${tableHeight}px`;
    }

    getDataCyLabelElement(index: number): string {
        return `table-label-inner-${index}`;
    }
}
